const currencyComparator = (c1, c2) =>
  c1.replace(/[$,]/g, '') - c2.replace(/[$,]/g, '');

export default currencyComparator;
